import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { mainStyles, theme } from '../../styles'
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import {
    Typography,//Textos
    Grid,useTheme
} from '@mui/material'//Se importan elementos de la librería material-ui
import Parser from 'html-react-parser';

import { fileActions, workflowActions } from '../../store/actions'//Acciones para redux
// import { useStyles } from './InformationalMessage1FormStyles'//Estílos específicos de los elementos de este componente
import {
    UseImage,
    CustomCounterAppBar,
    CustomAlert,
    CustomAlertMaterial, CustomLoadingOverlay
,Buttons } from '../../components'
import { InformationalMessage1FormFunctions } from './InformationalMessage1FormFunctions.js'//Métodos de éste componente (no requieren state)
import { coreFunctions } from '../../utils'//funciones del nucleo
import { useTranslation } from 'react-i18next';

export default function InformationalMessage1FormComponent(props) {
    const { useState, useEffect } = React//Hook para el state
    const gridContainer = {} //mainStyles.gridStyle()
     const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)

    const [widthButton, setWidthButton] = useState(0)
    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader    
    const [stateActual, setStateActual] = useState('')
    const [stateCurrent, setStateCurrent] = useState('')
    const [stateActualActivo, setStateActualActivo] = useState(false)
    const localStyles = {}//useStyles()//estílos de este componente (LoginStyles.js)
    const navigate = useNavigate()//Módulo "History" de react router

    //Estados de componente
    const [titleText, setTitleText] = useState('Prueba')
    const [fileCode, setFileCode] = useState('')
    const [fileDate, setFileDate] = useState('')
    const [textDescription, setDescription] = useState('')
    const [textButton, setButtonData] = useState('')
    const [performLogout, setPerformLogout] = useState(0)
    const [allowCancelFlow, setAllowCancelFlow] = useState(0)
    const [goToDashboard, setGoToDashboard] = useState(0)
    const [iconRefValue, setIconRefValue] = useState('')
    const [currentStage, setCurrentStage] = useState(0)
    const [stageProps, setStageProps] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [cancelAction, setCancelAction] = useState(false)
    const [continueAction, setContinueAction] = useState(false)
    const [timerSeconds, setTimerSeconds] = useState(25)
    const [activeFileInfo, setActiveFileInfo] = useState(false)
    const [fileId, setFileId] = useState(0)
    const [activaContinueButton, setActivaContinueButton] = useState(0)
    const [activeCargaInicial, setActiveCargaInicial] = useState(false)
    const [showAlertMaterial, setShowAlertMaterial] = useState(false)
    const [optionsList, setOptionsList] = useState([])


    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const wf = useSelector(state => state.Workflow)
    const file = useSelector(state => state.FileInfo)
    const cancelWF = useSelector(state => state.CancelWorkFlow)
    const continueWF = useSelector(state => state.ContinueWorkflow)
    const dispatch = useDispatch()
    const { t } = useTranslation();

    //Promesa general Init
    useEffect(() => {
        //Ancho de los botones
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)) {
            //Sí es móvil
            setWidthButton(90)
        } else {
            //Sí es desktop
            setWidthButton(100)
        }
        if (!stateActualActivo) {
            setFileId(location.state.folioId)
            // console.log("STate actual inicio: ", location.state.Name)
            setStateActual(location.state.Name)
            // console.log("State actual: ", file.items.Stage.Name)
            // console.log("location.state: ", location.state)
            let fileId = location.state.folioId
            // console.log("Folio ID: ", fileId)

            let stateStage = location.state.stage.Stage
            // console.log("state actual Stage--", stateStage)
            if (stateStage != undefined && stateStage != null) {
                let title = stateStage.Properties.find(element => element.Name == "TitleData")
                let description = stateStage.Properties.find(element => element.Name == "TextData")
                let buttonData = stateStage.Properties.find(element => element.Name == "ButtonData")
                let performLogout = stateStage.Properties.find(element => element.Name == "PerformLogout")
                let allowCancelFlow = stateStage.Properties.find(element => element.Name == "AllowCancelFlow")
                let goToDashboard = stateStage.Properties.find(element => element.Name == "GoToDashboard")
                let iconRef = stateStage.Properties.find(element => element.Name == "IconRef")
                let ativateContButton = stateStage.Properties.find(element => element.Name == "ActivateContinueButton")
                let optList = stateStage.Properties.find(element => element.Name == "OptionsList")

                setCurrentStage(stateStage.CurrentStageGroup)
                setTotalStage(stateStage.TotalStageGroups)

                // setFileId(fileId)
                setTitleText(title?.Value)
                setDescription(description?.Value)
                setButtonData(buttonData?.Value)
                setPerformLogout(performLogout?.Value)
                setAllowCancelFlow(allowCancelFlow?.Value)
                setGoToDashboard(goToDashboard?.Value)
                setIconRefValue(stateStage.Name == "Generación de documentos" ?
                    iconRef?.Value?.toString()?.concat(".gif") :
                    iconRef?.Value?.toString()?.concat(".jpg"))
                setActivaContinueButton(ativateContButton?.Value === undefined ? true : ativateContButton.Value)
                setTimerSeconds(ativateContButton?.Value == undefined || ativateContButton?.Value == false ? 25 : -1)
                if (optList != undefined && optList != null) {
                    let optionsArray = JSON.parse(optList?.Value)
                    setOptionsList(optionsArray)
                }
            } else {
                setActiveCargaInicial(true)
            }
            // console.log("File_Id", fileId)
            // console.log("location.state", location.state)
            dispatch(fileActions.GetFileInfo(fileId))
            setStateActualActivo(true)
        }
    })

    useEffect(() => {
        if (timerSeconds == 0) {
            //Realiza la peticion
            setTimerSeconds(25)
            setActiveFileInfo(true)
            setActiveCargaInicial(true)
            console.log("Realiza peticion nueva File Info: ")
            dispatch(fileActions.GetFileInfo(fileId))
        }
        // salir cuando lleguemos a 0
        if (!timerSeconds) return;

        // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
        const intervalId = setInterval(() => {
            setTimerSeconds(timerSeconds - 1);
        }, 1000);

        // clear interval al volver a renderizar para evitar pérdidas de memoria
        return () => clearInterval(intervalId);
    }, [timerSeconds]);


    // useEffect(() => {
    //     // console.log("stageProps: ", stageProps)
    //     if (stageProps != undefined && stageProps != 0) {
    //         setCurrentStage(stageProps.CurrentStageGroup)
    //         setTotalStage(stageProps.TotalStageGroups)
    //     }
    // }, [stageProps])

    // useEffect(() => {
    //     let stageName = location.state.stageName
    //     let stageId = location.state.stageId
    //     // setNameStage(stageName)        
    //     // console.log("location.state: ", location.state)
    //     // console.log("wf.items", wf.items)
    //     if (wf.items != undefined) {
    //         let items = wf.items
    //         items.forEach(i => {
    //             let stages = i.Stages
    //             let stgPrp = stages.find(j => j.Id === stageId && j.Name === stageName)
    //             setStageProps(stgPrp)
    //         });
    //     }
    // }, [wf])

    //Obtener valores de persistencia de datos y mostrarlos en interfaz
    useEffect(() => {
        setLoadView(file.loading)
        //Se cachan parámetros de salida en UI desde persistencia de datos, nombre, correo y teléfono
        if (file.items != undefined && activeCargaInicial) {
            console.log('FileInfo--Stage: ', file.items.Stage)
            let title = file.items.Stage.Properties.find(element => element.Name == "TitleData")
            let description = file.items.Stage.Properties.find(element => element.Name == "TextData")
            let buttonData = file.items.Stage.Properties.find(element => element.Name == "ButtonData")
            let performLogout = file.items.Stage.Properties.find(element => element.Name == "PerformLogout")
            let allowCancelFlow = file.items.Stage.Properties.find(element => element.Name == "AllowCancelFlow")
            let goToDashboard = file.items.Stage.Properties.find(element => element.Name == "GoToDashboard")
            let iconRef = file.items.Stage.Properties.find(element => element.Name == "IconRef")
            let ativateContButton = file.items.Stage.Properties.find(element => element.Name == "ActivateContinueButton")
            let optList = file.items.Stage.Properties.find(element => element.Name == "OptionsList")


            setCurrentStage(file.items.Stage.CurrentStageGroup)
            setTotalStage(file.items.Stage.TotalStageGroups)

            // console.log('FileInfo--Stage--iconRef: ', iconRef)
            // console.log('FileInfo--Stage--iconRef--VALUE: ', iconRef?.Value)
            // console.log("primeravez", { title, description, buttonData, performLogout })
            setFileId(file.items.Id)
            setTitleText(title?.Value)
            setDescription(description?.Value)
            setButtonData(buttonData?.Value)
            setPerformLogout(performLogout?.Value)
            setAllowCancelFlow(allowCancelFlow?.Value)
            setGoToDashboard(goToDashboard?.Value)
            setIconRefValue(file.items.Stage.Name == "Generación de documentos" ?
                iconRef?.Value?.toString()?.concat(".gif") :
                iconRef?.Value?.toString()?.concat(".jpg"))
            setActivaContinueButton(ativateContButton?.Value === undefined ? true : ativateContButton.Value)
            setTimerSeconds(ativateContButton?.Value == undefined || ativateContButton?.Value == false ? 25 : -1)
            // console.log('IconREF pantalla ', iconRef.Value)
            setFileDate(file.items.CreationDate)
            setFileCode(file.items.Folio)
            // console.log("stateActual: ", stateActual)
            // console.log("State consulta: ", file.items.Stage.Name)
            if (activeFileInfo && stateActual != file.items.Stage.Name) {
                let nextStage = file.items.Stage
                let stageName = nextStage.Name
                let stageId = nextStage.Id
                let folioId = file.items.Id
                let stage = file.items
                // console.log("Activa stage siguiente stateActual: ", stateActual)
                // console.log("Activa stage siguiente stateActual: ", stageName)

                let nextComponent = coreFunctions.GetLegoNext(stageName)
                InformationalMessage1FormFunctions.doNextStage({ auth ,navigate,nextComponent, stageName, stageId, stage, folioId })
            }
            if (optList != undefined && optList != null) {
                let optionsArray = JSON.parse(optList?.Value)
                setOptionsList(optionsArray)
            }
        }
    }, [file])

    useEffect(() => {
        if (cancelWF.items != undefined && cancelAction) {
            // console.log('cancelWF: ', cancelWF.items)
            if (goToDashboard == 1) {
                //TODO: Se implementa cuando exista dashboard
                // navigate('/')
            } else if (performLogout == 1) {
                navigate('/')
            } else {
                navigate('/')
            }
        }
    }, [cancelWF])

    useEffect(() => {
        setLoadView(continueWF.loading)
        if (continueWF.items != undefined && continueAction) {
            let nextStage = continueWF.items.Stage
            let stageName = nextStage.Name
            let stageId = nextStage.Id
            let folioId = location.state.folioId
            let stage = continueWF.items

            let nextComponent = coreFunctions.GetLegoNext(stageName)
            InformationalMessage1FormFunctions.doNextStage({ auth ,navigate,nextComponent, stageName, stageId, stage, folioId })
        }
    }, [continueWF])


    let handleContinue = () => {
        setContinueAction(true)
        let dataRequest = {
            File_Id: fileId
        }
        dispatch(workflowActions.ContinueWorkflowAction(dataRequest))
    }

    let handleCancel = () => {
        setShowAlertMaterial(true)
    }

    let handleAlerDialog = (pos) => {
        switch (pos) {
            case 'left':
                setShowAlertMaterial(false)
                console.log('Cancela modal')
                break;
            case 'right':
                setCancelAction(true)
                dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }))
                break;
            default:
                break;
        }
        setShowAlertMaterial(false)
    }

    //Comienza interfaz
    return (
        <div className={gridContainer.mainContainer} >
            <div className={gridContainer.container}>
                <div className={gridContainer.leftColumn}></div>
                <div className={gridContainer.centerColumn}>
                    <div className={gridContainer.centerColumnGral}>
                        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
                        <CustomCounterAppBar
                            initialStep={currentStage}
                            endingStep={totalStage} />
                        <div className={gridContainer.centerContent1}>
                            <div className={localStyles.centerContentInfoMessage} >
                                {/* <div className={localStyles.containerImage}>
                        <Grid container style={{ textAlign: 'center' }}>
                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                {console.log("iconRefValue: ", iconRefValue)}
                                {iconRefValue != undefined && iconRefValue != null && iconRefValue != '' ?
                                    <UseImage
                                        className={localStyles.imageIcon}
                                        src={iconRefValue}
                                        type='Image'
                                    // width={30}
                                    />
                                    : null
                                }
                            </Grid>
                        </Grid>
                    </div> */}
                                {iconRefValue != undefined && iconRefValue != null && iconRefValue != '' ?
                                    <UseImage
                                        className={localStyles.imageIcon}
                                        src={iconRefValue}
                                        type='Image'
                                    // width={30}
                                    />
                                    : null
                                }
                                <div className={localStyles.containerBody}>
                                    <Typography variant="h6"
                                        gutterBottom
                                        
          >{titleText}</Typography>
                                    <Typography variant="subtitle1"
                                        gutterBottom
                                         
                                    >{textDescription != undefined && textDescription != '' ? Parser(textDescription) : ""}
                                    </Typography>
                                    {optionsList.length > 0 ?
                                        <UseImage
                                            type="ListIcons"
                                            Options={optionsList}
                                            className={localStyles.root1}
                                            ListItemClass={localStyles.ListItemClass}
                                            ListItemIconClass={localStyles.ListItemIconClass}
                                            ListItemTextClass={localStyles.ListItemTextClass}
                                        />
                                        : null
                                    }
                                </div>

                                {activaContinueButton == 1 ?
                                    <Buttons
                                        className={localStyles.acceptBtn}
                                        size={widthButton} text_color='#ffffff'
                                        background_color={theme.palette.primary.main}
                                        // text={textButton}
                                        text="Continuar"
                                        type='button' click={handleContinue} />
                                    : null
                                }
                                {allowCancelFlow == 1 ?
                                    <Buttons
                                        className={localStyles.cancelBtn}
                                        size={widthButton} text_color={theme.palette.primary.main}
                                        background_color='#ffffff'
                                        border_color={theme.palette.primary.main}
                                        // text={textButton}
                                        text={t("general_cancel")}
                                        type='button' click={handleCancel} />
                                    : null
                                }
                            </div>
                        </div>
                        <CustomAlertMaterial
                            title={t("general_cancel")}
                            body='Al rechazar, deberás comenzar el proceso para una nueva solicitud. ¿Estas seguro de rechazar?'
                            leftButtonText={t("general_cancel")}
                            closeAction={() => setShowAlertMaterial(false)}
                            open={showAlertMaterial}
                            leftButtonAction={() => handleAlerDialog('left')}
                            rightButtonText={t("general_accept")}
                            rightButtonAction={() => handleAlerDialog('right')}
                        />
                    </div>
                </div>
                <div className={gridContainer.rightColumn}></div>
            </div>
        </div>)
}
